module.exports = __webpack_public_path__ + "static/img/btn_gift_2.da9b120.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/es/btn_gift_2.png
// module id = kqQT
// module chunks = 0